<template>
    <Dialog :draggable="false" :visible="props.visible" @update:visible="emit('close')" modal :dismissableMask="true"  :style="{ width: '500px' }" :breakpoints="{ '576px': '90vw' }" 
    :pt="{ header: { class:'d-flex justify-content-end pt-2 pe-md-2' } }">
        <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="token mb-2" style="width: 64px; height: 64px;">
            <img src="~/assets/images/logos/TopAuto_token_.svg" />
        </div>
        <h5 class="text-center fw-semiBold mb-40">Utilisation des crédits</h5>
        <table class="w-100 fsz-14 mb-4">
            <thead>
                <tr>
                    <th>Action</th>
                    <th>Coût en crédits</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Publication d’une nouvelle annonce</td>
                    <td>10 crédits</td>
                </tr>
                <tr>
                    <td>Réactivation d’une annonce expirée</td>
                    <td>4 crédits</td>
                </tr>
                <tr>
                    <td>Mise en avant ou options Premium (bientôt)</td>
                    <td>À venir</td>
                </tr>
            </tbody>
        </table>
        <p class="fsz-14">
            💡Gagnez en visibilité et réactivez facilement vos annonces depuis votre tableau de bord.
        </p>
    </div>
        <template #footer>
            <div class="d-flex flex-row-reverse  gap-2">
                    <button @click="emit('confirm')" class="xsmall-btn btn btn-solid-primary-600 disabled-pointer d-flex align-items-center gap-1">
                            <i class="material-symbols-rounded fsz-16">check</i> 
                            Fermer
                    </button>
                </div>
             
        </template>
        
    </Dialog>
  </template>
  
<script setup lang="ts">  
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});
  
const emit = defineEmits(['close', 'confirm']);

</script>
  
<style lang="scss">
  th, td {
    padding: 8px 12px;
    border-bottom: 1px solid #e0e0e0;
  }
</style>
  
